import type { Relation, RelationType } from "./relation.js";

/**
 * 轻量关系图：本次力学场景只需要"某对象当前处于哪种关系"（如木块搁在哪种接触面上），
 * 不需要化学装配图那种多端口拓扑，所以每个 (type, from) 只保留最新一条关系（后设覆盖前设）。
 * 未来电学垂直切片接入电路拓扑时，可在此基础上把 connect 类型扩展为多对多。
 */
export class AssemblyGraph {
  private readonly relations = new Map<string, Relation>();

  private key(type: RelationType, from: string): string {
    return `${type}::${from}`;
  }

  setRelation(id: string, type: RelationType, from: string, to: string, meta?: Record<string, unknown>): Relation {
    const relation: Relation = { id, type, from, to, meta };
    this.relations.set(this.key(type, from), relation);
    return relation;
  }

  getRelation(type: RelationType, from: string): Relation | undefined {
    return this.relations.get(this.key(type, from));
  }

  removeRelation(type: RelationType, from: string): void {
    this.relations.delete(this.key(type, from));
  }

  list(): Relation[] {
    return [...this.relations.values()];
  }

  reset(): void {
    this.relations.clear();
  }
}
